<template>
  <div class="not-found section fullscreen-content">
    <h2 class="centered">404</h2>
    <h1 class="section-title centered">Page not found</h1>
  </div>
</template>

<script>
export default {
  name: 'not-found'
}
</script>

<style lang="scss">
.not-found {
  padding-top: 200px;
  h2 {
    font-size: 40px;
  }
}
</style>
